export default __webpack_public_path__ + "static/media/sch4_w320.96bf2dab.jpg";